
import { Save } from 'lucide-react';

type ConfirmSalvaDialogProps = {
  onConferma: () => void;
  onAnnulla: () => void;
};

export const ConfirmSalvaDialog = ({ onConferma, onAnnulla }: ConfirmSalvaDialogProps) => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-3">
        <div className="w-11 h-11 rounded-full bg-[#1B365D]/10 flex items-center justify-center">
          <Save className="w-5 h-5 text-[#1B365D]" />
        </div>
      </div>
      <h2 className="text-base font-semibold mb-1 text-center">Salvare le modifiche?</h2>
      <p className="text-xs text-gray-400 mb-4">I dati verranno aggiornati definitivamente.</p>
      <div className="flex justify-center gap-3 mt-4">
        <button
          onClick={onAnnulla}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-500 hover:border-gray-400 hover:text-gray-700 transition-all"
        >
          Indietro
        </button>
        <button
          onClick={onConferma}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#1B365D] text-xs font-medium text-white hover:bg-[#1B365D]/90 transition-all"
        >
          Salva
        </button>
      </div>
    </div>
  );
};
